// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__9JgF7","desktop":"style_desktop__yMWgF","mobile":"style_mobile__a2kZm"};